import { useTranslation, Trans } from 'react-i18next';

export const useLocales = () => {
    const { t, i18n } = useTranslation();

    return { trans: t, Trans, i18n };
};
